export enum ErrorLogType {
  UserInputError = 'UserInputError',
  UnexpectedSystemStateError = 'UnexpectedSystemStateError',
  ServerError = 'ServerError',
  SessionError = 'SessionError',
  NetworkError = 'NetworkError',
  ApplicationError = 'ApplicationError',
  UnknownError = 'UnknownError',
}
